import React from "react"
import {
  MenuScroller,
  MenuTitleH3,
} from "../reusable/menu-slider/menu-slider.styles"
import MenuSlider from "../reusable/menu-slider/menu-slider"
import PropTypes from "prop-types"
import Video from "../reusable/video"

function DifficultyExplanationMenuSlider({ isOpen, setIsOpen, difficulty }) {
  return (
    <MenuSlider isOpen={isOpen} setIsOpen={setIsOpen}>
      <Video
        url={"https://www.youtube.com/embed/mDUJwZc6nlQ"}
        alt={"Difficulty video"}
      />
      <MenuScroller>
        {difficulty?.includes("(1/5)") && (
          <p>
            <MenuTitleH3>Casual Tours</MenuTitleH3>
            Level 1 tours are casual experiences that focus on enjoying the
            moment. They are perfect for families, those who prefer a more
            relaxed pace, or anyone with mobility considerations. These casual
            tours are ideal for entry level adventurers, as they can often be
            customized and made easier for guests.
          </p>
        )}

        {difficulty?.includes("(2/5)") && (
          <p>
            <MenuTitleH3>Easy Tours</MenuTitleH3>
            Level 2 tours include activities of easy to moderate difficulty
            throughout. On these tours the activity typically takes up 3-5 hours
            each day, and are often over easier terrain, making them perfect for
            those looking to explore at a comfortable pace. These could be
            considered family friendly for older children who are keen
            adventurers.
          </p>
        )}
        {difficulty?.includes("(3/5)") && (
          <p>
            <MenuTitleH3>Moderate Tours</MenuTitleH3>
            Level 3 tours are considered moderate trips and offer a full range
            of activities for guests who are intermediate adventurers. For
            example, a level 3 backpacking trip will cover longer distances, so
            a moderate fitness level, familiarity with the featured activity,
            and some backcountry experience are great to have.
          </p>
        )}
        {difficulty?.includes("(4/5)") && (
          <p>
            <MenuTitleH3>Difficult Tours</MenuTitleH3>
            Level 4 tours offer a difficult adventure, perfect for those with
            ample experience and who regularly take part in the chosen activity.
            If you are considering a Level 4 tour, you should have a good level
            of physical fitness and can expect longer and more intense
            activities, typically lasting between 5-8 hours each day.
          </p>
        )}
        {difficulty?.includes("(5/5)") && (
          <p>
            <MenuTitleH3>Challenging Tours</MenuTitleH3>
            Level 5 tours are challenging to undertake, and should be reserved
            for travellers with plenty of experience, a strong level of physical
            fitness, and good knowledge of the activity at hand. This is the top
            of our rating scale, and Level 5 itineraries often include high
            altitude, and long daily distances – think trekking in the Himalayas
            or a bike touring adventure with multiple ~100km days.
          </p>
        )}
      </MenuScroller>
    </MenuSlider>
  )
}

export default DifficultyExplanationMenuSlider

DifficultyExplanationMenuSlider.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  difficulty: PropTypes.string,
}
